$(document).on('turbo:load', function() {
  $('.smooth-scroll').on('click', function() {
      let scrollAnchor = $(this).attr('data-scroll'),
          scrollPoint = $(`section[data-anchor="${scrollAnchor}"]`).offset().top - 90;

      $('body, html').animate({
          scrollTop: scrollPoint
      }, 500);
      return false;
  })

  $(window).scroll(function() {
      let windscroll = $(window).scrollTop();
      let tabsSize = $(".content-scroll").width() - 40;
      if (windscroll >= 206) {
          $('.tabs-scroll').addClass('fixed-tabs').width(tabsSize);
          $('.content-scroll').addClass('fixed-content');

          $('.content-scroll section').each(function(i) {

            if ($(this).position().top <= windscroll + 152) {
              $('.tabs-scroll a.active').removeClass('active').width("auto");
              $('.tabs-scroll a').eq(i).addClass('active');
            }
          });

      } else {
        $('.tabs-scroll').removeClass('fixed-tabs');
        $('.content-scroll').removeClass('fixed-content');
        $('.tabs-scroll a.active').removeClass('active');
        $('.tabs-scroll a:first').addClass('active');
      }

  }).scroll();

  $('.smooth-scroll').on('click', function (e) {
    e.preventDefault();

    $(".active").removeClass("active");
    $(this).closest('li a').addClass("active");
  });

});
